import React, { useContext } from "react";
import { Label } from "structure/Document";
import { ContextEmitedCreditNotes } from "..";
import Select from "components/individual/SelectV4";
import CreditNoteEmitedStatus from "components/general/Forms/Selects/CreditNoteEmitedStatus";

export default function StatusFilter() {
  const hook = useContext(ContextEmitedCreditNotes);

  return (
    <div>
      <Label>Estatus</Label>
      <Select
        labelToDisplay="label"
        onChange={(item) => hook.updateStatus(item.value)}
        defaultSelected={{
          keyToCompare: "value",
          value: hook.status,
        }}
        options={async () => [
          {
            label: "Todos",
            value: null,
          },
          {
            label: "Emitidas",
            value: 13,
          },
          {
            label: "Canceladas",
            value: 15,
          },
        ]}
      />
    </div>
  );
}
